<form [formGroup]="form" [ngClass]="{'d-none': isAdditionalStudent && kind === FormAffinity.Form}">
    @for(field of filteredFields; track field.ID) {
        @switch (field.Field?.FieldType) {
            @case (CustomFieldType.CheckedList) {
                @let checkedListField = CustomFieldDisplayItem.AsCheckedList(field.Field!);
                <lib-checkbox-group
                    [formControl]="field | method: GetFormControl"
                    [isViewOnly]="isViewOnly">
                    <ng-container label>
                        {{field.Name}}
                    </ng-container>
                    <lib-checkbox-group-item *ngFor="let option of checkedListField.Options"
                    [value]="option">
                        {{option}}
                    </lib-checkbox-group-item>
                </lib-checkbox-group>
            }
            @case (CustomFieldType.DropDownList) {
                @let dropDownListField = CustomFieldDisplayItem.AsDropDownList(field.Field!);
                <lib-input-select
                    [formControl]=" field | method: GetFormControl"
                    [sortBy]="keepOrder"
                    [placeholderText]="dropDownListField.Hint ? dropDownListField.Hint : ''"
                    [isViewOnly]="isViewOnly">
                    <ng-container label>
                        {{field.Name}}
                    </ng-container>
                    <lib-input-select-item *ngFor="let option of  dropDownListField.Options"
                        [value]="option">
                        {{option}}
                    </lib-input-select-item>
                </lib-input-select>
            }
            @case (CustomFieldType.Email) {
                @let emailField = CustomFieldDisplayItem.AsEmail(field.Field!);
                <lib-input-text
                    [formControl]=" field | method: GetFormControl"
                    [placeholderText]="emailField.Hint ? emailField.Hint : ''"
                    [isViewOnly]="isViewOnly">
                    <ng-container label>
                        {{field.Name}}
                    </ng-container>
                </lib-input-text>
            }
            @case (CustomFieldType.MultiLine) {
                @let multiLineField = CustomFieldDisplayItem.AsMultiLine(field.Field!);
                <lib-input-text-area
                    [formControl]=" field | method: GetFormControl"
                    [placeholderText]="multiLineField.Hint ? multiLineField.Hint : ''"
                    [isViewOnly]="isViewOnly">
                    <ng-container label>
                        {{field.Name}}
                    </ng-container>
                </lib-input-text-area>
            }
            @case (CustomFieldType.Policy) {
                @let policyField = CustomFieldDisplayItem.AsPolicy(field.Field!);
                <lib-checkbox
                    [formControl]=" field | method: GetFormControl"
                    [isViewOnly]="isViewOnly">
                    <ng-container label>
                        {{field.Name}}
                    </ng-container>
                    {{policyField.Statement}}
                    @if (policyField.Url) {
                    <div>
                        <a [href]="policyField.Url | method: PreparePolicyURL" target="_blank" i18n="@@CommonClickToView">Click to View</a>
                    </div>
                    }
                </lib-checkbox>
            }
            @case (CustomFieldType.RadioList) {
                @let radioListField = CustomFieldDisplayItem.AsRadioList(field.Field!);
                <lib-radio-group
                    [formControl]=" field | method: GetFormControl"
                    [isViewOnly]="isViewOnly">
                    <ng-container label>
                        {{field.Name}}
                    </ng-container>
                    <lib-radio-group-item *ngFor="let option of radioListField.Options"
                        [value]="option">
                        {{option}}
                    </lib-radio-group-item>
                </lib-radio-group>
            }
            @case (CustomFieldType.Text) {
                @let textField = CustomFieldDisplayItem.AsText(field.Field!);
                <lib-input-text
                    [formControl]=" field | method: GetFormControl"
                    [placeholderText]="textField.Hint ? textField.Hint : ''"
                    [isViewOnly]="isViewOnly">
                    <ng-container label>
                        {{field.Name}}
                    </ng-container>
                </lib-input-text>
            }
        }
    }
</form>